const STATUS_MAP = {
  "1": {
    "evaluation-invendo": "Dağıtıcıya Yönlendirildi",
    "productization": "Ön Değerlendirme",
    "otoProduct": "Çalışıyor"
  },
  "2": {
    "evaluation-invendo": "Değerlendiriciye Yönlendirildi",
    "productization": "Değerlendirme",
    "otoProduct": "Süreç Yönetimi Ekibine Yönlendirildi"
  },
  "3": {
    "evaluation-invendo": "Karar Vericiye Yönlendirildi",
    "productization": "MvP/PoC",
    "otoProduct": "MvP/PoC"
  },
  "4": {
    "evaluation-invendo": "Red Edildi",
    "productization": "Kabul Edilmedi",
    "otoProduct": "Kabul Edilmedi"
  },
  "5": "Invendoya Yönlendirildi",
  "6": {
    "evaluation-invendo": "Onaylandı",
    "productization": "Canlı",
    "otoProduct": "Canlı"
  },
  "7": "Silindi",
  "8": "Hayata Geçti",
  "9": (loc) => loc === "otoProduct" ? "Ertelendi" : "Beklemede",
  "10": "İptal Edildi"
};

/**
 * 
 * @param {string | number} id 
 * @param {string} location 
 * @returns string
 */
export const suggestionStatus = (id, location = "evaluation-invendo") => {
  const status = STATUS_MAP[String(id)];

  if (typeof status === 'function') {
    return status(location);
  }

  if (typeof status === 'object' && status !== null) {
    return status[location] || "";
  }

  return status || "";
};
